export function normalizeNames(list: string[]) {
  return list.map(s => String(s || '').trim()).filter(Boolean)
}

export function setKey(list: string[]) {
  return [...list].sort().join('|')
}